import * as React from "react";
import { useState, useContext, useEffect } from "react";
import { IMaskInput } from 'react-imask';
import {MaskedRange} from 'imask';
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {ValueContext} from '~common/components/form-def-field-fc';
import {ICGFormControl} from '~common/components/icg-form-control';
import {cloneDeep} from 'lodash'
import Input from '@mui/material/Input';
import {EventContext} from '~common/form/icg-definition-data-provider';
import { FromNumberContext, ToNumberContext }  from "~common/components/fields/number-range-fc";
import { NumericFormat, NumberFormat, NumericFormatProps } from 'react-number-format';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {  
      width: "100%",
    },
    displayText: {
      width: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
  })
);

interface NumberProps {
  fieldDefinition: any;
  policyMessages?: any;
  contextType?: string;
  readOnlyOverride?: boolean;
  error?: any;
}

function numberWithCommas(x: string) {
  return x.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const NumberField: React.FC<NumberProps> = ({
  fieldDefinition,
  policyMessages,
  contextType,
  readOnlyOverride,
  path,
  onKeyDown
}) => {
  const classes = useStyles();    

  // Setting the inital value and setValue hook based on the context passed in from form def field, instead of useState
  // setFieldVal will pass the value up to the parent component that houses the context.
  var parentContext = useContext(ValueContext);
  
  if (contextType == "from") {
    parentContext = useContext(FromNumberContext);

  } else if (contextType == "to") {
    parentContext = useContext(ToNumberContext);
  }

  const [fieldVal, setFieldVal] = parentContext;
  // var initValue = parseFloat(fieldVal.replace(/,/g, '').replace(/\$/g,''))
  // const [localVal, setLocalVal] = useState(initValue);
  const [localVal, setLocalVal] = useState(fieldVal?fieldVal.toString():'');
  const [localMessageText, setLocalMessageText] = useState("");
  const [localMessageClass, setLocalMessageClass] = useState("");
  const eventContext = useContext(EventContext);

  var { precision } = fieldDefinition;
  const isCurrency = (fieldDefinition.type == "Currency") || (fieldDefinition.variant == "Currency")
  if(!precision){
    if(isCurrency){
    // If the field is currency and a precision is not specified, we default to 2
    precision = 2
    } else {
      // If the field is not currency and a precision is not specified, we default to 0
      precision = 0
    }
  }

  const onChange = (event) => {
    setLocalVal(event.target.value);
  }

  const onBlur = (event) => {

    let numericValue = parseFloat(event.target.value.replace(/,/g, '').replace(/\$/g,''));

    if (numericValue !== fieldVal) {
      
      setFieldVal(numericValue);
    }

    var newLocalVal = event.target.value;
    setLocalVal(newLocalVal);

  }

    // Listen for changes from the parent def
    useEffect(() => {
      if (!isCurrency && typeof fieldVal === "string") {
        let numericValue = parseFloat(fieldVal.replace(/,/g, '').replace(/\$/g,''));
        setFieldVal(numericValue);
      } else {
        var newLocalVal = ""
        if (fieldVal || fieldVal == 0) {
          newLocalVal = fieldVal.toString()
          if (isCurrency){
            var decimalIDX = newLocalVal.toLowerCase().indexOf(".")
            var missingPrecision = decimalIDX+1 - (newLocalVal.length - precision)
            if (decimalIDX == -1) {
              newLocalVal = newLocalVal+".00";
            } else if (missingPrecision > 0 ) {
              for (missingPrecision >0; missingPrecision--;){
                newLocalVal = newLocalVal+"0";
              }
            }else {
              newLocalVal = newLocalVal;
            }
            newLocalVal = numberWithCommas(newLocalVal)
          } 
        }
        setLocalVal(newLocalVal);
      }
      
    }, [fieldVal])

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { eventTypes } = fieldDefinition;
    if (eventTypes && eventContext) {
      const [, setTriggeredEvent] = eventContext;
      const keyDef = eventTypes.find(k => 
        k.type === "KeyEvent" &&
        k.key === event.key &&
        !!k.shiftKey === event.shiftKey &&
        !!k.ctrlKey === event.ctrlKey &&
        !!k.altKey === event.altKey
      );

      if (keyDef && setTriggeredEvent) {
        event.preventDefault(); // Prevent the key from being typed
        setTriggeredEvent({ path, event, keyDef });
        return; // Stop processing if we found a match
      }

    }

    // 2. Fallback to standard onKeyDown if provided
    if (onKeyDown) {
      onKeyDown(event);
    }
  }    
  
  if (fieldDefinition.mode == "Display") {
    return (
    <ICGFormControl fieldDefinition={fieldDefinition} policyMessages={policyMessages} readOnlyOverride={readOnlyOverride}> 
        <div name={fieldDefinition.key} className={classes.displayText} data-field-value={localVal || ""}>
          {localVal || "--"}
        </div>
    </ICGFormControl>
    );
  }
  var htmlProps = {}
  if(fieldDefinition.maxLength) {
    htmlProps["maxLength"] = fieldDefinition.maxLength;
  }

  htmlProps["data-roi-path"] = path;
  htmlProps["data-field-key"] = fieldDefinition.key;
  htmlProps["data-field-path"] = path;
  htmlProps["data-field-type"] = fieldDefinition.type;

    return (
      <ICGFormControl fieldDefinition={fieldDefinition} policyMessages={policyMessages} readOnlyOverride={readOnlyOverride} fieldControlMessage={localMessageText} fieldControlClass={localMessageClass}> 
      <div>
          <NumericFormat 
            value={localVal}
            placeholder={fieldDefinition.placeholder || ""}
            className={classes.textField}
            onBlur={onBlur}     
            onChange={onChange}
            onKeyDown={handleKeyDown}
            customInput={Input}     
            inputProps={htmlProps}
            name={fieldDefinition.key}
            allowNegative={true}
            decimalScale={precision}
            thousandSeparator={isCurrency}
            fixedDecimalScale={false}
            />
          </div>
      </ICGFormControl> 
    )
};

export default NumberField;
